import { useSelector } from 'react-redux'

import { selectFeatureFlagsSettled } from '../../features/featureFlags/selectors'
import { AFFILIATE_TASKS_UI, TASK_FIXES, TASK_REMINDERS, TASK_REMINDERS_UI } from '../../config/featureFlagKeys'
import usePinnedFeatureFlag from '../../hooks/usePinnedFeatureFlag'
import { useStoredUser } from '../../hooks/useStoredUser'

const AFFILIATE_ROLES = ['affiliate', 'affiliateGroupsAdmin']

export const useTaskFlags = () => {
  const { enabled: fixesOn } = usePinnedFeatureFlag(TASK_FIXES)
  const { enabled: remindersOn } = usePinnedFeatureFlag(TASK_REMINDERS)
  const { enabled: reminderControlsOn } = usePinnedFeatureFlag(TASK_REMINDERS_UI)
  const { enabled: affiliateTasksOn } = usePinnedFeatureFlag(AFFILIATE_TASKS_UI)
  const flagsSettled = useSelector(selectFeatureFlagsSettled)
  const { viewer, viewerReady } = useStoredUser(remindersOn || affiliateTasksOn)
  const affiliateRules = affiliateTasksOn && AFFILIATE_ROLES.includes(viewer?.role)

  return {
    fixesOn,
    remindersOn,
    reminderUiOn: remindersOn && reminderControlsOn,
    affiliateTasksOn,
    affiliateRules,
    peopleMode: remindersOn || affiliateRules,
    viewer,
    viewerReady: flagsSettled && viewerReady,
  }
}
